<div class="revertPage" *ngIf="period">
    <h2 class="revertPage-title"[i18nKey]="'revert.period.page.launch.simulation.in.progress'"></h2>
    <h2 class="revertPage-title"[i18nKey]="'simulation.page.launch.simulation.in.progress.info'"></h2>
    <div class="revertPage-img"></div>
    <div class="revertPage-title"[i18nKey]="'revert.period.page.action'"></div>
    <div class="revertPage-period">
        <kiwi-period [period]="period"></kiwi-period>
    </div>
</div>
